import { render, staticRenderFns } from "./PurchaseGalleryProvider.vue?vue&type=template&id=2060b2ae&scoped=true&"
import script from "./PurchaseGalleryProvider.vue?vue&type=script&lang=ts&"
export * from "./PurchaseGalleryProvider.vue?vue&type=script&lang=ts&"
import style0 from "./PurchaseGalleryProvider.vue?vue&type=style&index=0&id=2060b2ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2060b2ae",
  null
  
)

export default component.exports